import { z } from 'zod';
import { requiredString } from '../helpers';
export const Calendly_Get_Available_Slots_1_ConfigValidator = z.object({
    calendlyConnection: requiredString('Calendly connection is required'),
    eventTypeUri: requiredString('Event type is required'),
    startTime: requiredString('Start time is required'),
    endTime: requiredString('End time is required'),
    timezone: z.string().optional()
});
//# sourceMappingURL=calendly-get-available-slots-1.js.map